import { Foote, Copy } from "./IndexStyle";

const Footer = () => {
  return (
    <Foote>
      <Copy>
        <p>
          © 2022 by KemayTechnology. Todos los derechos reservados. Si tuviese
          algún inconveniente por favor contactarnos al siguiente correo:
          davisperezg@gmail.com Version: 1.2.7 | Powered by @davisperezg
        </p>
      </Copy>
    </Foote>
  );
};

export default Footer;
